import type { ReactNode } from "react";

import { Menu, Popover } from "react-aria-components";

import styles from "./filter-menu.module.css";

export type FilterItem = {
	label: ReactNode;
	value: string;
};

type FilterProps = {
	children: (item: FilterItem) => ReactNode;
	items: FilterItem[];
};

export function FilterMenu({ children, items }: FilterProps): ReactNode {
	return (
		<Popover>
			<Menu className={styles.dropdown} items={items}>
				{(item) => {
					return children(item);
				}}
			</Menu>
		</Popover>
	);
}
